import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import AppInfos from '../../../components/ParametersPage/AppInfos';

const mapStateToProps = (state: StoreState) => {
	const { parametersPage } = state;
	const { usedSpace, freeSpace } = parametersPage;
	return { usedSpace, freeSpace };
};

export default connect(mapStateToProps)(AppInfos);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/AppInfos/index.tsx